/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import * as $ from "jquery";
import {IconPathProvider, TeamAppsUiContext} from "../TeamAppsUiContext";
import {UiToolButtonConfig} from "../../generated/UiToolButtonConfig";

export class UiToolButton {
	private $button: JQuery;
	private id: string;

	constructor(config: UiToolButtonConfig, clickHandler: (button: UiToolButton) => void, context: TeamAppsUiContext) {
		this.id = config.id;
		let buttonContentHtml = context.templateRegistry.createTemplateRenderer(config.template, null).render(config.recordData);
		this.$button = $(`<div class="UiToolButton ${config.grayOutIfNotHovered ? 'gray-out-if-not-hovered' : ''}">${buttonContentHtml}</div>`)
			.click(() => {
				clickHandler(this)
			});
	}

	getId() {
		return this.id;
	}

	getMainDomElement(): JQuery {
		return this.$button;
	}
}
